import React, { createContext, ReactNode, useCallback, useState } from "react";

type PinnableItem = {
  item: string;
  model: any; // Consider replacing 'any' with a more specific type if possible
};

type PinnableItemsContextType = {
  pinnedItem: PinnableItem | null;
  hoveredItem: PinnableItem | null;
  availableItems: string[];
  pin: (item: string, model: any) => void;
  unpin: () => void;
  setHovered: (item: string, model: any) => void;
  clearHovered: () => void;
};

export const PinnableItemsContext = createContext<PinnableItemsContextType>({} as PinnableItemsContextType);
// Create a provider component
export const PinnableItemsProvider: React.FC<{
  children: ReactNode;
  availableItems: string[];
}> = ({ children, availableItems }) => {
  const [pinnedItem, setPinnedItem] = useState<PinnableItem | null>(null);
  const [hoveredItem, setHoveredItem] = useState<PinnableItem | null>(null);

  const pin = useCallback(
    (item: string, model: any) => {
      if (availableItems.includes(item)) {
        setPinnedItem({ item, model });
      }
    },
    [availableItems]
  );

  const unpin = useCallback(() => {
    setPinnedItem(null);
  }, []);

  const setHovered = useCallback(
    (item: string, model: any) => {
      if (availableItems.includes(item)) {
        setHoveredItem({ item, model });
      }
    },
    [availableItems]
  );

  const clearHovered = useCallback(() => {
    setHoveredItem(null);
  }, []);

  const value: PinnableItemsContextType = {
    pinnedItem,
    hoveredItem,
    availableItems,
    pin,
    unpin,
    setHovered,
    clearHovered,
  };

  return <PinnableItemsContext.Provider value={value}>{children}</PinnableItemsContext.Provider>;
};
